import React, { Component } from 'react';

import './Perfil.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import Parallax from 'parallax-js';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';
import OwlCarousel from 'react-owl-carousel2';
import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	views
} from '../../settings';

import {
	Person,
	HoveredImage,
	Compromisso
} from '../../components/';

class Perfil extends Component {

	constructor() {
		super();

        this.images = images;

        this.state = {
            width: window.innerWidth,
        	mapYearActive2016: '',
        	mapYearActive2017: '',
        	mapYearActive2018: 'maps__timeline__year--active',

        	tempoYearActive2016: '',
        	tempoYearActive2017: '',
        	tempoYearActive2018: 'tempo_grafico_img--active',

        	tempoYearButtonActive2016: '',
        	tempoYearButtonActive2017: '',
        	tempoYearButtonActive2018: 'year_button--active',

        	cargosYearButtonActive2016: '',
        	cargosYearButtonActive2017: '',
        	cargosYearButtonActive2018: 'year_button--active',

			superintendentes_mulher: 2,
			superintendentes_homem: 3,

			gerentes_mulher: 8,
			gerentes_homem: 9,

			coordenadores_mulher: 7,
			coordenadores_homem: 10,

			analistas_mulher: 88,
			analistas_homem: 121,

			assistentes_mulher: 17,
			assistentes_homem: 20,

			apoios_mulher: 6,
			apoios_homem: 5,

			estagiarios_mulher: 15,
			estagiarios_homem: 20,

			aprendizes_mulher: 1,
			aprendizes_homem: 1,

        	tempoYearTotal: 333,

        	funcionariosRJ: 115,
        	estagiariosRJ: 13,
        	funcionariosSP: 183,
        	estagiariosSP: 22,

        	showStateSP: false,
        	showStateRJ: false,
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.changeYearCargos = this.changeYearCargos.bind(this);
        this.changeTempoYear = this.changeTempoYear.bind(this);
        this.showStateLabel = this.showStateLabel.bind(this);
        this.hideStateLabel = this.hideStateLabel.bind(this);
	}

    changeYear(year) {
		switch (year) {
			case '2016':
				this.setState({
		        	mapYearActive2016: 'maps__timeline__year--active',
		        	mapYearActive2017: '',
		        	mapYearActive2018: '',
		        	
		        	funcionariosRJ: 130,
		        	estagiariosRJ: 12,
		        	
		        	funcionariosSP: 154,
		        	estagiariosSP: 21
				});
				break;

			case '2017':
				this.setState({
		        	mapYearActive2016: '',
		        	mapYearActive2017: 'maps__timeline__year--active',
		        	mapYearActive2018: '',
		        	
		        	funcionariosRJ: 137,
		        	estagiariosRJ: 18,
		        	
		        	funcionariosSP: 154,
		        	estagiariosSP: 16
				});
				break;

			case '2018':
				this.setState({
		        	mapYearActive2016: '',
		        	mapYearActive2017: '',
		        	mapYearActive2018: 'maps__timeline__year--active',

		        	
		        	funcionariosRJ: 115,
		        	estagiariosRJ: 13,
		        	
		        	funcionariosSP: 183,
		        	estagiariosSP: 22
				});
				break;
		}
    }

    changeTempoYear(year) {
		switch (year) {
			case '2016':
				this.setState({
		        	tempoYearActive2016: 'tempo_grafico_img--active',
		        	tempoYearActive2017: '',
		        	tempoYearActive2018: '',
		        	tempoYearButtonActive2016: 'year_button--active',
		        	tempoYearButtonActive2017: '',
		        	tempoYearButtonActive2018: '',
		        	tempoYearTotal: 317,
				});
				break;

			case '2017':
				this.setState({
		        	tempoYearActive2016: '',
		        	tempoYearActive2017: 'tempo_grafico_img--active',
		        	tempoYearActive2018: '',
		        	tempoYearButtonActive2016: '',
		        	tempoYearButtonActive2017: 'year_button--active',
		        	tempoYearButtonActive2018: '',
		        	tempoYearTotal: 323,
				});
				break;

			case '2018':
				this.setState({
		        	tempoYearActive2016: '',
		        	tempoYearActive2017: '',
		        	tempoYearActive2018: 'tempo_grafico_img--active',
		        	tempoYearButtonActive2016: '',
		        	tempoYearButtonActive2017: '',
		        	tempoYearButtonActive2018: 'year_button--active',
		        	tempoYearTotal: 333,
				});
				break;
		}
    }

    changeYearCargos(year) {
		switch (year) {
			case '2016':
				this.setState({
		        	cargosYearButtonActive2016: 'year_button--active',
		        	cargosYearButtonActive2017: '',
		        	cargosYearButtonActive2018: '',

					superintendentes_mulher: 3,
					superintendentes_homem: 3,

					gerentes_mulher: 10,
					gerentes_homem: 10,

					coordenadores_mulher: 6,
					coordenadores_homem: 13,

					analistas_mulher: 85,
					analistas_homem: 102,

					assistentes_mulher: 18,
					assistentes_homem: 21,

					apoios_mulher: 7,
					apoios_homem: 6,

					estagiarios_mulher: 11,
					estagiarios_homem: 22,

					aprendizes_mulher: 0,
					aprendizes_homem: 0
				});
				break;

			case '2017':
				this.setState({
		        	cargosYearButtonActive2016: '',
		        	cargosYearButtonActive2017: 'year_button--active',
		        	cargosYearButtonActive2018: '',

					superintendentes_mulher: 2,
					superintendentes_homem: 3,

					gerentes_mulher: 10,
					gerentes_homem: 8,

					coordenadores_mulher: 6,
					coordenadores_homem: 10,

					analistas_mulher: 88,
					analistas_homem: 102,

					assistentes_mulher: 22,
					assistentes_homem: 25,

					apoios_mulher: 7,
					apoios_homem: 6,

					estagiarios_mulher: 13,
					estagiarios_homem: 19,

					aprendizes_mulher: 1,
					aprendizes_homem: 1
				});
				break;

			case '2018':
				this.setState({
		        	cargosYearButtonActive2016: '',
		        	cargosYearButtonActive2017: '',
		        	cargosYearButtonActive2018: 'year_button--active',

					superintendentes_mulher: 2,
					superintendentes_homem: 3,

					gerentes_mulher: 8,
					gerentes_homem: 9,

					coordenadores_mulher: 7,
					coordenadores_homem: 10,

					analistas_mulher: 88,
					analistas_homem: 121,

					assistentes_mulher: 17,
					assistentes_homem: 20,

					apoios_mulher: 6,
					apoios_homem: 5,

					estagiarios_mulher: 15,
					estagiarios_homem: 20,

					aprendizes_mulher: 1,
					aprendizes_homem: 1
				});
				break;
		}
    }

    showStateLabel(state) {
    	switch (state) {
    		case "sp":
    			this.setState({ showStateSP: true });
    			break;

    		case "rj":
    			this.setState({ showStateRJ: true });
    			break;
    	}
    }

    hideStateLabel(state) {
    	switch (state) {
    		case "sp":
    			this.setState({ showStateSP: false });
    			break;

    		case "rj":
    			this.setState({ showStateRJ: false });
    			break;
    	}
    }

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('5.2 Perfil');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view', 
			'perfil'
		];


		var mapYearClass2016 = [
			'maps__timeline__year',
			'maps__timeline__year--2016',
			this.state.mapYearActive2016
		];

		var mapYearClass2017 = [
			'maps__timeline__year',
			'maps__timeline__year--2017',
			this.state.mapYearActive2017
		];

		var mapYearClass2018 = [
			'maps__timeline__year',
			'maps__timeline__year--2018',
			this.state.mapYearActive2018
		];


		var tempoYearClass2016 = [
			'tempo_grafico_img',
			'tempo_grafico_img--2016',
			this.state.tempoYearActive2016
		];

		var tempoYearClass2017 = [
			'tempo_grafico_img',
			'tempo_grafico_img--2017',
			this.state.tempoYearActive2017
		];

		var tempoYearClass2018 = [
			'tempo_grafico_img',
			'tempo_grafico_img--2018',
			this.state.tempoYearActive2018
		];


		var tempoYearButton2016 = [
			'year_button',
			'year_button--2016',
			this.state.tempoYearButtonActive2016
		];

		var tempoYearButton2017 = [
			'year_button',
			'year_button--2017',
			this.state.tempoYearButtonActive2017
		];

		var tempoYearButton2018 = [
			'year_button',
			'year_button--2018',
			this.state.tempoYearButtonActive2018
		];


		var cargosYearButton2016 = [
			'year_button',
			'year_button--2016',
			this.state.cargosYearButtonActive2016
		];

		var cargosYearButton2017 = [
			'year_button',
			'year_button--2017',
			this.state.cargosYearButtonActive2017
		];

		var cargosYearButton2018 = [
			'year_button',
			'year_button--2018',
			this.state.cargosYearButtonActive2018
		];


		const totalCargos = this.state.superintendentes_mulher +
							this.state.superintendentes_homem +
							this.state.gerentes_mulher +
							this.state.gerentes_homem +
							this.state.coordenadores_mulher +
							this.state.coordenadores_homem +
							this.state.analistas_mulher +
							this.state.analistas_homem +
							this.state.assistentes_mulher +
							this.state.assistentes_homem +
							this.state.apoios_mulher +
							this.state.apoios_homem +
							this.state.estagiarios_mulher +
							this.state.estagiarios_homem +
							this.state.aprendizes_mulher +
							this.state.aprendizes_homem;

		const totalCargosHomem = this.state.superintendentes_homem +
								this.state.gerentes_homem +
								this.state.coordenadores_homem +
								this.state.analistas_homem +
								this.state.assistentes_homem +
								this.state.apoios_homem +
								this.state.estagiarios_homem +
								this.state.aprendizes_homem;

		const totalCargosMulher = this.state.superintendentes_mulher +
								this.state.gerentes_mulher +
								this.state.coordenadores_mulher +
								this.state.analistas_mulher +
								this.state.assistentes_mulher +
								this.state.apoios_mulher +
								this.state.estagiarios_mulher +
								this.state.aprendizes_mulher;

		const totalFuncionarios = this.state.funcionariosSP + this.state.funcionariosRJ;
		const totalEstagiarios = this.state.estagiariosSP + this.state.estagiariosRJ;

		const stateSPClass = [
			'maps__name',
			'maps__name--sp',
			(this.state.showStateSP) ? 'maps__name--shown' : ''
		];

		const stateRJClass = [
			'maps__name',
			'maps__name--rj',
			(this.state.showStateRJ) ? 'maps__name--shown' : ''
		];

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>5.2 Perfil - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>5.2</span> Perfil</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Pessoas</p>
		        			</div>
		        		</header>

		        		<div className="views__content first_view row">
			        		<div className="container">
				        		<div className="column">
					       			<Fade bottom>
					        			<p className="first_paragraph">A diversidade e igualdade de oportunidades está presente em nossa equipe. Em relação ao gênero, por exemplo, nosso quadro é formado por</p>
					        			<h2 className="first_cta">
					        				<strong className="green_text">43,2%</strong> <strong>de mulheres</strong> e <strong className="green_text">56,8%</strong> <strong>de homens</strong>
					        			</h2>
					        			<p className="second_paragraph">Há a mesma proporção entre homens e mulheres na nossa liderança: dos <strong>39 cargos de chefia</strong>, 43,5% são ocupados por mulheres e 56,4% por homens.</p>
				        			</Fade>
				        		</div> 
			        		</div> 
		        		</div>

		        		<div className="views__content titled_view colaboradores_perfil_view row">
			        		<div className="container">
				        		<div className="column">
						       		<Fade bottom>
					        			{/*<h3 className="titled_view__title titled_view__title--no-line">Perfil dos colaboradores</h3>*/}
				        				<h2 className="section_title">
				        					Perfil dos colaboradores<br />
					        				<span className="gri_label"><text>GRI 102-8</text></span>
					        			</h2>
					        			{/*<h2 className="section_title">
					        				Perfil dos colaboradores por estado
					        				<br />
					        				<span className="gri_label"><text>GRI 102-8</text></span>
					        			</h2>*/}
					        		</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section views__content--colaboradores row">
			        		<div className="side side--left">
			        			<div className="total_side">
					        		<div className="number">{ totalCargosMulher }</div>
					        		<div className="text">Mulheres</div>
			        			</div>
			        			<div className="image image--left">
				        			<HoveredImage
				        				image1={ this.images.perfil_mulher }
				        				image2={ this.images.perfil_mulher_hover } />
			        			</div>
			        		</div>

			        		<div className="center">
			        			<div className="cargos_nav">
			        				<p>Veja o dados dos cargos por ano, escolha um abaixo:</p>
				        			<div className="cargos_buttons">
			        					<div className={ cargosYearButton2016.join(' ') } onClick={ this.changeYearCargos.bind(null, '2016') }>2016</div>
			        					<div className={ cargosYearButton2017.join(' ') } onClick={ this.changeYearCargos.bind(null, '2017') }>2017</div>
			        					<div className={ cargosYearButton2018.join(' ') } onClick={ this.changeYearCargos.bind(null, '2018') }>2018</div>
				        			</div>
			        			</div>

				        		<div className="word">Cargos</div>

				        		<div className="data_list">

					        		<div className="data_list__item">
						        		<div className="item__number item__number--mulher">{ this.state.superintendentes_mulher }</div>
						        		<div className="item__text"><span>Superintendentes</span></div>
						        		<div className="item__number item__number--homem">{ this.state.superintendentes_homem }</div>
					        		</div>

					        		<div className="data_list__item">
						        		<div className="item__number item__number--mulher">{ this.state.gerentes_mulher }</div>
						        		<div className="item__text"><span>Gerentes</span></div>
						        		<div className="item__number item__number--homem">{ this.state.gerentes_homem }</div>
					        		</div>

					        		<div className="data_list__item">
						        		<div className="item__number item__number--mulher">{ this.state.coordenadores_mulher }</div>
						        		<div className="item__text"><span>Coordenadores</span></div>
						        		<div className="item__number item__number--homem">{ this.state.coordenadores_homem }</div>
					        		</div>

					        		<div className="data_list__item">
						        		<div className="item__number item__number--mulher">{ this.state.analistas_mulher }</div>
						        		<div className="item__text"><span>Analistas</span></div>
						        		<div className="item__number item__number--homem">{ this.state.analistas_homem }</div>
					        		</div>

					        		<div className="data_list__item">
						        		<div className="item__number item__number--mulher">{ this.state.assistentes_mulher }</div>
						        		<div className="item__text"><span>Assistentes</span></div>
						        		<div className="item__number item__number--homem">{ this.state.assistentes_homem }</div>
					        		</div>

					        		<div className="data_list__item">
						        		<div className="item__number item__number--mulher">{ this.state.apoios_mulher }</div>
						        		<div className="item__text"><span>Apoios</span></div>
						        		<div className="item__number item__number--homem">{ this.state.apoios_homem }</div>
					        		</div>

					        		<div className="data_list__item">
						        		<div className="item__number item__number--mulher">{ this.state.estagiarios_mulher }</div>
						        		<div className="item__text"><span>Estagiários*</span></div>
						        		<div className="item__number item__number--homem">{ this.state.estagiarios_homem }</div>
					        		</div>

					        		<div className="data_list__item">
						        		<div className="item__number item__number--mulher">{ this.state.aprendizes_mulher }</div>
						        		<div className="item__text"><span>Jovens aprendizes*</span></div>
						        		<div className="item__number item__number--homem">{ this.state.aprendizes_homem }</div>
					        		</div>
				        		</div>

				        		<div className="total">
					        		<div className="text">Total:</div>
					        		<div className="number">{ totalCargos }</div>
				        		</div>

			        		</div>

			        		<div className="side side--right">
			        			<div className="total_side">
					        		<div className="number">{ totalCargosHomem }</div>
					        		<div className="text">Homens</div>
			        			</div>
			        			<div className="image image--right">
				        			<HoveredImage
				        				image1={ this.images.perfil_homem }
				        				image2={ this.images.perfil_homem_hover } />
			        			</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section views__content--description row">
				        	<Fade bottom>
			        			<p>*Os funcionários exercem jornadas de oito horas, os estagiários de seis horas e os aprendizes de quatro horas.</p>
				        	</Fade>
		        		</div>

		        		<div className="views__content titled_view regions_view row">
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
					        			<h3 className="titled_view__title titled_view__title--no-line">Perfil dos colaboradores</h3>
				        				<h2 className="section_title">
				        					por estado<br />
					        				<span className="gri_label"><text>GRI 102-8</text></span>
					        			</h2>

				        				<div className="maps__total maps__total--funcionarios">
				        					<div className="number">{ totalFuncionarios }</div>
				        					<div className="text">Funcionários</div>
				        				</div>

				        				<div className="maps__total maps__total--estagiarios">
				        					<div className="number">{ totalEstagiarios }</div>
				        					<div className="text">Estagiários</div>
				        				</div>
				        			</Fade>

				        			<div className="maps">
			        					<img src={ this.images.perfil_map_base } />

			        					<div className={ stateSPClass.join(' ') }>SP</div>
			        					<div className={ stateRJClass.join(' ') }>RJ</div>

			        					<div className="maps__number maps__number--funcionarios sp"
							                onMouseEnter={ this.showStateLabel.bind(null, 'sp') }
							                onMouseLeave={ this.hideStateLabel.bind(null, 'sp') }>{ this.state.funcionariosSP }</div>
			        					<div className="maps__number maps__number--estagiarios sp"
							                onMouseEnter={ this.showStateLabel.bind(null, 'sp') }
							                onMouseLeave={ this.hideStateLabel.bind(null, 'sp') }>{ this.state.estagiariosSP }</div>

			        					<div className="maps__number maps__number--funcionarios rj"
							                onMouseEnter={ this.showStateLabel.bind(null, 'rj') }
							                onMouseLeave={ this.hideStateLabel.bind(null, 'rj') }>{ this.state.funcionariosRJ }</div>
			        					<div className="maps__number maps__number--estagiarios rj"
							                onMouseEnter={ this.showStateLabel.bind(null, 'rj') }
							                onMouseLeave={ this.hideStateLabel.bind(null, 'rj') }>{ this.state.estagiariosRJ }</div>
			        				</div>

				        			<Fade bottom>
				        				<div className="maps__timeline">
				        					<div className={ mapYearClass2016.join(' ') } onClick={ this.changeYear.bind(null, '2016') }>2016</div>
				        					<div className={ mapYearClass2017.join(' ') } onClick={ this.changeYear.bind(null, '2017') }>2017</div>
				        					<div className={ mapYearClass2018.join(' ') } onClick={ this.changeYear.bind(null, '2018') }>2018</div>
				        				</div>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>

		        		<div className="views__content diversidades_view row">
			        		<div className="container">
			        			<img src={ this.images.perfil_homem_table } class="person_table person_table--homem" />
			        			<img src={ this.images.perfil_mulher_table } class="person_table person_table--mulher" />
			        			<img src={ this.images.perfil_base_pessoas } class="person_table person_table--base" />

				        		<div className="column">
						       		<Fade bottom>
					        			<h2 className="section_title">
					        				Diversidade e igualdade<br />de oportunidades<br />
					        				<span className="gri_label"><text>GRI 405-1</text></span>
					        			</h2>

					        			<div className="diversidades_table">
						        			<div className="diversidades_table__header">
							        			<div className="header__column">Cargos</div>
							        			<div className="header__column">Abaixo de<br />30 anos</div>
							        			<div className="header__column">De 30 a<br />50 anos</div>
							        			<div className="header__column">Acima de<br />50 anos</div>
						        			</div>
						        			<div className="diversidades_table__body">

							        			<div className="body__line">
								        			<div className="body__column">Superintendentes</div>
								        			<div className="body__column">-</div>
								        			<div className="body__column">3</div>
								        			<div className="body__column">2</div>
							        			</div>

							        			<div className="body__line">
								        			<div className="body__column">Gerentes</div>
								        			<div className="body__column">-</div>
								        			<div className="body__column">13</div>
								        			<div className="body__column">4</div>
							        			</div>

							        			<div className="body__line">
								        			<div className="body__column">Coordenadores</div>
								        			<div className="body__column">-</div>
								        			<div className="body__column">9</div>
								        			<div className="body__column">8</div>
							        			</div>

							        			<div className="body__line">
								        			<div className="body__column">Analistas</div>
								        			<div className="body__column">43</div>
								        			<div className="body__column">147</div>
								        			<div className="body__column">19</div>
							        			</div>

							        			<div className="body__line">
								        			<div className="body__column">Assistentes</div>
								        			<div className="body__column">14</div>
								        			<div className="body__column">17</div>
								        			<div className="body__column">6</div>
							        			</div>

							        			<div className="body__line">
								        			<div className="body__column">Apoios</div>
								        			<div className="body__column">1</div>
								        			<div className="body__column">9</div>
								        			<div className="body__column">1</div>
							        			</div>

							        			<div className="body__line">
								        			<div className="body__column">Estagiários</div>
								        			<div className="body__column">33</div>
								        			<div className="body__column">2</div>
								        			<div className="body__column">-</div>
							        			</div>

							        			<div className="body__line">
								        			<div className="body__column">Jovens aprendizes</div>
								        			<div className="body__column">2</div>
								        			<div className="body__column">-</div>
								        			<div className="body__column">-</div>
							        			</div>

							        			<div className="body__line body__line--space"></div>

							        			<div className="body__line body__line--total">
								        			<div className="body__column">Total</div>
								        			<div className="body__column">93</div>
								        			<div className="body__column">200</div>
								        			<div className="body__column">40</div>
							        			</div>

						        			</div>
					        			</div>
					        		</Fade>
				        		</div>
			        		</div>
		        		</div>


		        		<div className="views__content titled_view tempo_view row">
			        		<div className="container">
				        		<div className="column column--half">
						       		<Fade bottom>
					        			<h3 className="titled_view__title titled_view__title--no-line">Perfil por</h3>
					        			<h2 className="section_title">tempo<br />de casa</h2>

					        			<div className="tempo_grafico_nav">
						        			<div className="cargos_nav">
						        				<p>Veja o dados por ano, escolha um abaixo:</p>
							        			<div className="cargos_buttons">
								        			<div className={ tempoYearButton2016.join(' ') } onClick={ this.changeTempoYear.bind(null, '2016') }>2016</div>
								        			<div className={ tempoYearButton2017.join(' ') } onClick={ this.changeTempoYear.bind(null, '2017') }>2017</div>
								        			<div className={ tempoYearButton2018.join(' ') } onClick={ this.changeTempoYear.bind(null, '2018') }>2018</div>
							        			</div>
						        			</div>
					        			</div>
					        		</Fade>
				        		</div>

				        		<div className="column column--half">
						       		<Fade bottom>
					        			<div className="tempo_grafico">
					        				<img src={ this.images.perfil_tempo_grafico_2016 } className={ tempoYearClass2016.join(' ') } />
					        				<img src={ this.images.perfil_tempo_grafico_2017 } className={ tempoYearClass2017.join(' ') } />
					        				<img src={ this.images.perfil_tempo_grafico_2018 } className={ tempoYearClass2018.join(' ') } />
					        			</div>

					        			<div className="tempo_grafico_legenda">
					        				<ul>
						        				<li>Mais de 20 anos</li>
												<li>De 16 a 20 anos</li>
												<li>De 11 a 15 anos</li>
												<li>De seis a dez anos</li>
												<li>Até cinco anos</li>
					        				</ul>
					        			</div>

					        			<div className="tempo_grafico_total">
					        				<span>Total</span>
					        				<span className="number">{ this.state.tempoYearTotal }</span>
					        			</div>
					        		</Fade>
				        		</div>
			        		</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { Perfil };
